import { IPlaningTransfer } from '@/interface/IPlanningProviderResponse'

export const SetJsonTransferSave = (selected: IPlaningTransfer[], projectId: string, bankLists: any[], saveType: string, emailTypeId: number) => {
    console.log('SetJsonTransferSave', bankLists)
    return selected.map((o: IPlaningTransfer) => {
        let newObject = {
            saveType:								saveType,
            emailTypeId:							emailTypeId,
            projectId:								parseInt(projectId),	
            unitCode:								o.unitCode,	
            unitId: 								o.unitId,
            addressNo: 								o.addressNo,
            signId:				 					o.signId,
            signActivityId:							o.signActivityId,
            flagActiveSign:				 			o.activeSign,
            bookingId:								o.bookingId,
            prospectId:				 				o.prospectId,		
            transferDateReal: 						convertFormatDateForSave(o.transferDateReal),
            transferPlanDate:						convertFormatDateForSave(o.transferPlanDate),
            transferPlanDateBefore:					convertFormatDateForSave(o.transferPlanDateBefore),
            transferPlanDateSp:						convertFormatDateForSave(o.transferPlanDateSp),
            transferPlanDateSpBefore:				convertFormatDateForSave(o.transferPlanDateSpBefore),
            transferId: 							o.transferId,
            transferCRRemark:						o.transferCRRemark,
            transferTypeId: 						o.transferTypeId,
            transferOutDateHistory:					convertFormatDateForSave(o.transferOutDateHistory),
            flagActiveTransferBefore:				o.flagActiveTransferBefore,
            flagActiveTransfer:						o.flagActiveTransfer,
            flagTransferAdjustLetter:				o.flagTransferAdjustLetter,
            flagTransferCancelLetter:				o.flagTransferCancelLetter,
            flagTransferChangeLetter: 				o.flagTransferChangeLetter,
            flagTransferOutLetter: 					o.flagTransferOutLetter,
            flagTransferOutCancelLetter: 			o.flagTransferOutCancelLetter,
            flagTransferLetter: 		    		o.flagTransferLetter,	 
            flagTransferLetterBefore:				o.flagTransferLetterBefore,
            transferLetterDateBefore:				convertFormatDateForSave(o.transferLetterDateBefore),
            mortgageCompValue:						o.mortgageCompValue,
            operationId: 							o.operationId,
            operationTime: 							o.operationTime,
            lettTransRemark: 						o.lettTransRemark,
            contactStatusId: 						o.contactStatusId,
            receivePromotionId: 					o.receivePromotionId,
            joinEventId: 							o.joinEventId,
            purposeOfBuyId: 						o.purposeOfBuyId,
            customerDepositStock: 					o.customerDepositStock,
            payStatus100pcCusOverPay: 				o.payStatus100pcCusOverPay,
            payStatus100pc: 						o.payStatus100pc,
            reasonStatus100pc: 						o.reasonStatus100pc,
            expectTranMonth: 						convertFormatDateForSave(o.expectTranMonth),
            bankId:									bankLists.filter(x => x.unitId == o.unitId).length > 0 ? bankLists.filter(x => x.unitId == o.unitId)[0].bankLists[0].usedBankId : o.bankId,
            creditAppv: 							o.creditAppv,
            useBankReason: 							o.useBankReasonOther == o.useBankReason ? o.useBankReason : o.useBankReasonOther,
            transferStatusId: 						o.transferStatusId,
            crPlan: 								convertFormatDateForSave(o.crPlan),
            crId: 									o.crId,
            inspection1Id:							o.inspection1Id,
            inspection1PlanPJDate:					convertFormatDateForSave(o.inspection1PlanPJDate),
            inspection1PlanCRDate: 					convertFormatDateForSave(o.inspection1PlanCRDate),
            inspection1PlanCRTime: 					o.inspection1PlanCRTime,
            inspection1TypeId: 						o.inspection1TypeId,
            inspection1AppointmentStatusId: 		o.inspection1AppointmentStatusId,
            inspection1PlanCRDateEdit: 				convertFormatDateForSave(o.inspection1PlanCRDateEdit),
            inspection2Id:							o.inspection2Id,
            inspection2PlanPJDate:					convertFormatDateForSave(o.inspection2PlanPJDate),
            inspection2PlanCRDate: 					convertFormatDateForSave(o.inspection2PlanCRDate),
            inspection2PlanCRTime: 					o.inspection2PlanCRTime,
            inspection2TypeId: 						o.inspection2TypeId,
            inspection2AppointmentStatusId: 		o.inspection2AppointmentStatusId,
            inspection2PlanCRDateEdit: 				convertFormatDateForSave(o.inspection2PlanCRDateEdit),
            inspection3Id:							o.inspection3Id,
            inspection3PlanPJDate:					convertFormatDateForSave(o.inspection3PlanPJDate),
            inspection3PlanCRDate: 					convertFormatDateForSave(o.inspection3PlanCRDate),
            inspection3PlanCRTime: 					o.inspection3PlanCRTime,
            inspection3TypeId: 						o.inspection3TypeId,
            inspection3AppointmentStatusId: 		o.inspection3AppointmentStatusId,
            inspection3PlanCRDateEdit: 				convertFormatDateForSave(o.inspection3PlanCRDateEdit),
            inspection4Id:							o.inspection4Id,
            inspection4PlanPJDate:					convertFormatDateForSave(o.inspection4PlanPJDate),
            inspection4PlanCRDate: 					convertFormatDateForSave(o.inspection4PlanCRDate),
            inspection4PlanCRTime: 					o.inspection4PlanCRTime,
            inspection4TypeId: 						o.inspection4TypeId,
            inspection4AppointmentStatusId: 		o.inspection4AppointmentStatusId,
            inspection4PlanCRDateEdit: 				convertFormatDateForSave(o.inspection4PlanCRDateEdit),
            inspectionNumLatest:					o.inspectionNumLatest,
            inspectionSendRoomDateLatest:			convertFormatDateForSave(o.inspectionSendRoomDateLatest),
            inspectionAppointmentStatusLatest:		o.inspectionAppointmentStatusLatest,
            inspectionPlanCRDateLatest:				convertFormatDateForSave(o.inspectionPlanCRDateLatest),
            inspectionPlanCRTimeLatest:				o.inspectionPlanCRTimeLatest,
            inspectionTypeTextLatest:				o.inspectionTypeTextLatest,
            sapContractNo:                          o.sapContractNo,     
            flagHaveAddress:                        o.flagHaveAddress,
            flagInspectorContractor:                o.flagInspectorContractor,
            inspectorName:                          o.inspectorName,
            BankLists: 								bankLists.filter(x => x.unitId == o.unitId).length > 0 ? bankLists.filter(x => x.unitId == o.unitId)[0].bankLists : [],
            transferUpdatedDate:                    o.transferUpdatedDate,
            crComment:                              o.crComment
        } as any
        return newObject
    })
}

export const SetColumnFreeze = (columnAddressLock: boolean, columnCustomerNameLock: boolean) => {
    if (columnAddressLock === true) {
        ChangeFreezeColumnAddress(true)
    } else {
        ChangeFreezeColumnAddress(false)
        ChangeFreezeColumnName(false)
    }

    if (columnCustomerNameLock === true) {
        ChangeFreezeColumnAddress(true)
        ChangeFreezeColumnName(true)
    } else {
        ChangeFreezeColumnName(false)
    }
}

const ChangeFreezeColumnAddress = (disabled: boolean) => {
    let getElementTB: any = window.document.getElementsByClassName("text-start fixed-address")
    if (disabled) {
        for (let index = 0; index < getElementTB.length; index++) {
            getElementTB[index].style.position = "sticky"
            getElementTB[index].style.position = "-webkit-sticky"
            getElementTB[index].style.left = "184px"
            if (index === 0) getElementTB[index].style.zIndex = "999"
            if (index !== 0) getElementTB[index].style.zIndex = "990"
            getElementTB[index].style.background = "#f0f0f0"
            getElementTB[index].style.borderRight = "1px solid #dddddd"
        }
    } else {
        for (let index = 0; index < getElementTB.length; index++) {
            getElementTB[index].style.position = null
            getElementTB[index].style.position = null
            getElementTB[index].style.left = null
            getElementTB[index].style.zIndex = null
            getElementTB[index].style.background = null
            getElementTB[index].style.borderRight = null
        }
    }
}

const ChangeFreezeColumnName = (disabled: boolean) => {
    let getElementTB: any = window.document.getElementsByClassName("text-start fixed-name")
    if (disabled) {
        for (let index = 0; index < getElementTB.length; index++) {
            getElementTB[index].style.position = "sticky"
            getElementTB[index].style.position = "-webkit-sticky"
            getElementTB[index].style.left = "303px"
            if (index === 0) getElementTB[index].style.zIndex = "999"
            if (index !== 0) getElementTB[index].style.zIndex = "990"
            getElementTB[index].style.background = "#f0f0f0"
            getElementTB[index].style.borderRight = "1px solid #dddddd"
        }
    } else {
        for (let index = 0; index < getElementTB.length; index++) {
            getElementTB[index].style.position = null
            getElementTB[index].style.position = null
            getElementTB[index].style.left = null
            getElementTB[index].style.zIndex = null
            getElementTB[index].style.background = null
            getElementTB[index].style.borderRight = null
        }
    }
}

const convertFormatDateForSave = (date: string) => {
    if (date != "" && date != undefined) {
        return `${date.replaceAll('-', '')}`
    }
    return date
}